import { AssigneeData } from '@/types/CreditRequest/AssigneeData';
import { ContractFixationItemAssignee } from '@/types/CreditRequest/ContractFixationData';
import { StateCreator } from 'zustand';

import { CreditRequestSlice } from '../../use-credit-request-store';

export type AssigneeValues = {
  taxes: number;
  valueWithoutTaxes: number;
  fee: number;
  feeValue: number;
  netAmount: number;
  grossValue: number;
  assigneeId?: string;
};

export type AssigneesSlice = {
  hasAssignees: boolean;
  assigneeList: AssigneeData[];
  assigneeToEdit: AssigneeData | null;
  isAssigneeModalOpen: boolean;
  contractAssignees: ContractFixationItemAssignee[];
  contractAssigneesCalculatedValues: AssigneeValues[];
  setAssigneeList: (value: AssigneeData[]) => void;
  setHasAssignees: (value: boolean) => void;
  setAssigneeToEdit: (value: AssigneeData | null) => void;
  setAssigneeModalOpen: (value: boolean) => void;
  setContractAssignees: (value: ContractFixationItemAssignee[]) => void;
  setContractAssigneesCalculatedValues: (assigneesValues: AssigneeValues[]) => void;
};

export const assigneesSliceInitialState = {
  hasAssignees: false,
  assigneeList: [],
  assigneeToEdit: null,
  isAssigneeModalOpen: false,
  contractAssignees: [],
  contractAssigneesCalculatedValues: [],
};

export const createAssigneesSlice: StateCreator<AssigneesSlice & CreditRequestSlice, [], [], AssigneesSlice> = set => ({
  ...assigneesSliceInitialState,
  setAssigneeList: value => set(state => ({ ...state, assigneeList: value })),
  setHasAssignees: value => set(state => ({ ...state, hasAssignees: value })),
  setAssigneeToEdit: value =>
    set(state => ({
      ...state,
      assigneeToEdit: value,
      isAssigneeModalOpen: value !== null,
    })),
  setAssigneeModalOpen: value => set(state => ({ ...state, isAssigneeModalOpen: value })),
  setContractAssignees: value => set(state => ({ ...state, contractAssignees: value })),
  setContractAssigneesCalculatedValues: value =>
    set(state => ({
      ...state,
      contractAssigneesCalculatedValues: value,
    })),
});
